var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCollapse = function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.22 19.779a.75.75 0 0 0 1.06 0L9.5 15.561v3.627a.75.75 0 0 0 1.5 0V13.75a.75.75 0 0 0-.75-.75H4.81a.75.75 0 0 0 0 1.5h3.627L4.22 18.718a.75.75 0 0 0 0 1.061M19.779 4.22a.75.75 0 0 0-1.06 0L14.5 8.438V4.811a.75.75 0 0 0-1.5 0v5.438c0 .414.336.75.75.75h5.438a.75.75 0 0 0 0-1.5H15.56l4.218-4.219a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  })));
};
export default SvgCollapse;